<template>
  <!-- 最新资讯 -->
  <div class="dynamic">
    <div class="box">
      <div class="header">
        <div class="title">最新资讯</div>
        <div class="border"></div>
      </div>
      <div class="body">
        <div class="top">
          <div
            class="item"
            v-for="item in dynamicTitleList"
            :key="item.id"
            @click="selectTitle(item.id)"
          >
            <div :class="item.id == titleID ? 'active' : ''">
              {{ item.title }}
            </div>
          </div>
        </div>

        <div class="center">
          <div class="list">
            <div
              class="item"
              v-for="item in titleID == 1 ? dynamicList : dynamicList1"
              :key="item.id"
              @mouseenter="dynamicEnter(item.id)"
              @mouseleave="dynamicLeave"
              :style="
                listId == item.id
                  ? `background-image: url(${dynamicOpen});`
                  : ''
              "
            >
              <div class="open" v-if="listId == item.id">
                <div class="title">{{ item.title }}</div>
                <div class="source">来源：{{ item.source }}</div>
                <div class="text">{{ item.text }}</div>
                <router-link target="_blank" :to="{ path: item.path, query: { id: item.id } }">
                  <div class="more">
                    <div>查看详情</div>
                    <img :src="more" alt="" />
                  </div>
                </router-link>
              </div>

              <div class="close" v-else>
                <img :src="item.logo" alt="" />
                <div>{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="bottom">
          <div
            v-for="item in dynamicTitleList"
            :key="item.id"
            :class="titleID == item.id ? 'active' : ''"
            @click="selectTitle(item.id)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import dynamicOpen from "../../../assets/home/dynamicOpen.png";

import more from "../../../assets/home/more.png";

import dynamicLogo1 from "../../../assets/home/dynamicLogo1.png";
import dynamicLogo2 from "../../../assets/home/dynamicLogo2.png";
import dynamicLogo3 from "../../../assets/home/dynamicLogo3.png";
import dynamicLogo4 from "../../../assets/home/dynamicLogo4.png";
import dynamicLogo5 from "../../../assets/home/dynamicLogo5.png";
import dynamicLogo6 from "../../../assets/home/dynamicLogo6.png";
import dynamicLogo7 from "../../../assets/home/dynamicLogo7.png";
import dynamicLogo8 from "../../../assets/home/dynamicLogo8.png";

export default {
  setup() {
    return reactive({
      dynamicOpen: dynamicOpen,
      more: more,
      titleID: 1,
      dynamicTitleList: [
        {
          id: 1,
          title: "行业新闻",
        },
        {
          id: 2,
          title: "公司动态",
        },
      ],
      listId: 0,
      dynamicList: [
        {
          id: 1,
          title: "传统物业与现在的智慧物业相比，智慧物业管理系统有哪些优势？ ",
          text: "智慧物业是利用互联网等高科技手段，让普通物业管理模式变得更加智能化。其实，好的智慧物业离我们的生活还很遥远......",
          source: "客户通科技",
          logo: dynamicLogo1,
          path: "/pc/dynamic/newsdetails",
        },
        {
          id: 2,
          title: "10大物业管理软件排名",
          text: "排名或者榜单之类应该由行业权威部门来弄的，如题，从来没有国家或行业权威对物业管理软件进行过相关排名，所以.......",
          source: "客户通科技",
          logo: dynamicLogo2,
          path: "/pc/dynamic/newsdetails",
        },
        {
          id: 3,
          title: "智慧物业管理系统建设智慧社区为何这么受欢迎？",
          text: "近几年信息技术飞速发展，数字化产品也逐渐呈现在人们眼前，各种智能机器人、智能检测体温设备、无人机驾驶汽车的出现都......",
          source: "客户通科技",
          logo: dynamicLogo3,
          path: "/pc/dynamic/newsdetails",
        },
        {
          id: 4,
          title: "疫情之下，智慧物业管理系统的建设，有了更多的“用武之地”",
          text: "疫情以来，随着社区站在外防内防扩散的第一线，物业服务企业的精准排查、消防消杀、严格门禁、提供上门服务等能力也得到检验......",
          source: "客户通科技",
          logo: dynamicLogo4,
          path: "/pc/dynamic/newsdetails",
        },
      ],
      dynamicList1: [
        {
          id: 1,
          title: "惠阳苑竣工案例",
          text: "和谐社会，平安为先，经济发展，稳定为要，创建智能化平安小区工程是加快经济发展，保障人民群众安居乐业的重要载体......",
          source: "上海何伟安防",
          logo: dynamicLogo5,
          path: "/pc/dynamic/dynamicdetails",
        },
        {
          id: 2,
          title: "香岛原墅小区智能安防系统建设",
          text: "2021年8月1号国家应急管理部公布的《高层民用建筑消防安全管理规定》禁止在高层民用建筑公共门厅、疏散走道、楼梯间......",
          source: "上海何伟安防",
          logo: dynamicLogo6,
          path: "/pc/dynamic/dynamicdetails",
        },
        {
          id: 3,
          title: "宝山八村高空抛物系统集成服务项目",
          text: "2019年11月，最高人民法院印发《关于依法妥善审理高空抛物、坠物案件的意见》，明确对于故意高空抛物者，根据具体情形......",
          source: "上海何伟安防",
          logo: dynamicLogo7,
          path: "/pc/dynamic/dynamicdetails",
        },
        {
          id: 4,
          title: "宝山区11个消防救援站WIFI6项目",
          text: "为了对消防员绿色上网行为进行更好的管理，上海畅月物业管理有限公司响应宝山消防站的号召，对宝山11个消防站点及保障大队室......",
          source: "上海何伟安防",
          logo: dynamicLogo8,
          path: "/pc/dynamic/dynamicdetails",
        },
      ],
    });
  },
  methods: {
    selectTitle(id) {
      this.titleID = id;
    },
    dynamicEnter(id) {
      this.listId = id;
    },
    dynamicLeave() {
      this.listId = 0;
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 1180px) {
  .dynamic {
    min-width: 1180px;
  }
}
.dynamic {
  background: rgba(243, 244, 248, 0.4);
  padding: 60px 0;
  margin-top: 80px;
}
.dynamic .box {
  width: 1180px;
  margin: 0 auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
}
.body .top {
  display: flex;
  justify-content: space-evenly;
}
.body .top .item div {
  width: 240px;
  font-size: 18px;
  color: #333;
  text-align: center;
  padding: 20px 0;
  cursor: pointer;
}
.body .top .item .active {
  color: #248efb;
  border-bottom: 3px solid #248efb;
}

.center {
  margin-top: 40px;
}
.center .list {
  display: flex;
  justify-content: space-between;
}
.center .list .item {
  width: 285px;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
.center .list .item:hover {
  animation: itemHover 2s;
}
@keyframes itemHover {
  0% {
    background-size: 100% 100%;
  }
  100% {
    background-size: 120% 120%;
  }
}
.center .list .item .close img {
  width: 285px;
}
.center .list .item .close div {
  width: 230px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 auto;
  padding: 20px 20px 40px;
}
.center .list .item .open {
  padding: 40px 20px;
}
.center .list .item .open .title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 14px;
  color: #fff;
}
.center .list .item .open .source {
  font-size: 14px;
  color: #89c3ff;
  margin-top: 20px;
}
.center .list .item .open .text {
  font-size: 12px;
  color: #fff;
  margin-top: 30px;
}
.center .list .item .open .more {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #fff;
  margin-top: 150px;
  cursor: pointer;
}
.center .list .item .open .more img {
  width: 14px;
  margin-left: 8px;
}

.bottom {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
.bottom div {
  width: 40px;
  height: 6px;
  background: #d8d8d8;
  margin-right: 20px;
}
.bottom .active {
  background-color: #248efb;
}
</style>
